import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ae29a92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pull-down-select-wrapper" }
const _hoisted_2 = ["id", "name", "disabled"]
const _hoisted_3 = {
  key: 0,
  hidden: "hidden"
}
const _hoisted_4 = ["value", "selected"]
const _hoisted_5 = ["id", "name", "disabled"]
const _hoisted_6 = {
  key: 0,
  hidden: "hidden"
}
const _hoisted_7 = ["label"]
const _hoisted_8 = ["value", "selected"]
const _hoisted_9 = { class: "error-message" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Field, {
      name: _ctx.name,
      "model-value": _ctx.modelValue,
      rules: _ctx.rules
    }, {
      default: _withCtx(({ field, errors, errorMessage }) => [
        _createElementVNode("div", {
          class: _normalizeClass(["select-body", { disabled: _ctx.disabled }])
        }, [
          (!_ctx.isOptionsNested)
            ? (_openBlock(), _createElementBlock("select", {
                key: 0,
                onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
                id: _ctx.name,
                name: _ctx.name,
                class: _normalizeClass({ invalid: errorMessage }),
                disabled: _ctx.disabled
              }, [
                (_ctx.placeHolder)
                  ? (_openBlock(), _createElementBlock("option", _hoisted_3, _toDisplayString(_ctx.placeHolder), 1))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: option.value,
                    key: option.value,
                    selected: option.value === field.value
                  }, _toDisplayString(option.label), 9, _hoisted_4))
                }), 128))
              ], 42, _hoisted_2))
            : (_openBlock(), _createElementBlock("select", {
                key: 1,
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
                id: _ctx.name,
                name: _ctx.name,
                class: _normalizeClass({ invalid: errorMessage }),
                disabled: _ctx.disabled
              }, [
                (_ctx.placeHolder)
                  ? (_openBlock(), _createElementBlock("option", _hoisted_6, _toDisplayString(_ctx.placeHolder), 1))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (optgroup) => {
                  return (_openBlock(), _createElementBlock("optgroup", {
                    key: optgroup.key,
                    label: optgroup.label
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optgroup.options, (option) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: option.value,
                        key: option.value,
                        selected: option.value === field.value
                      }, _toDisplayString(option.label), 9, _hoisted_8))
                    }), 128))
                  ], 8, _hoisted_7))
                }), 128))
              ], 42, _hoisted_5))
        ], 2),
        _createElementVNode("span", _hoisted_9, _toDisplayString(errors[0]), 1)
      ]),
      _: 1
    }, 8, ["name", "model-value", "rules"])
  ]))
}